import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpIntercepterBasicAuthService implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // console.log(error);
        if (error.status != 404) {
          this.router.navigate(['/error'], { queryParams: { errorCode: error.status } });
        }
        // let lastActionDateTime = new Date();
        // if (error.status == 401) {
        // } else if (error.status == 403) {
        // } else if (error.status == 0 || error.status == 500) {
        // }
        // else {
        // }

        // If you want to return a new response:
        //return of(new HttpResponse({body: [{name: "Default value..."}]}));

        // If you want to return the error on the upper level:
        return throwError(error);

        // or just return nothing:
        // return EMPTY;
      })
    );
  }
}



